export default {
  boms: (state) => {
    return state.boms;
  },
  bom: (state) => {
    return state.bom;
  },

  bomCode: (state) => {
    return state.bomCode;
  },

  bomByCode: (state) => {
    return state.bomByCode;
  },

  bomCommodities: (state) => {
    return state.bomCommodities;
  },

  bomNavigation: (state) => {
    return state.bomNavigation;
  },

  setting: (state) => {
    return state.setting;
  },

  production: (state) => {
    return state.production;
  },
  productionItem: (state) => {
    return state.productionItem;
  },
  productionNavigation: (state) => {
    return state.productionNavigation;
  },
  productionCode: (state) => {
    return state.productionCode;
  },

  productionDetailsReport: (state) => {
    return state.productionDetailsReport;
  },

  productionCalculate: (state) => {
    return state.productionCalculate;
  },

  productionCostsReport: (state) => {
    return state.productionCostsReport;
  },

  producedProductsReport: (state) => {
    return state.producedProductsReport;
  },

  consumedRawMaterials: (state) => {
    return state.consumedRawMaterials;
  },
};
